import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const useCategoryNavigation = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [cate, setCate] = useState(params.ntype ?? 'all');

    const changeCategory = (newCate: string) => {
        if (newCate !== cate) {
            setCate(newCate);
            navigate(`/announcement/${newCate}`);
        }
    };

    return { cate, setCate, changeCategory };
};
